var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-apex-charts',{attrs:{"type":"candlestick","height":"400","options":_vm.apexChatData.candlestickChart.chartOptions,"series":_vm.apexChatData.candlestickChart.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }